import React, { useEffect } from 'react';
import {Col, Row} from 'reactstrap';
import {connect, useSelector} from "react-redux";

// components
import LabelList from "./_list";
import {showLoader} from "../../../components/loader/loader";

// actions
import {getStateByPath} from "../../../redux/selectors";
import {ADD_STATE, REMOVE_STATE, setApp} from "../../../redux/actions/generics/IndexedActions";

function Label (props) {
    const path = props.path || 'configuration/label';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(path, props.app);
    },[]);


    return (
        <>
            <div>
                {loading && showLoader()}
                <Row>
                    <Col md="12">
                        {componentState && <LabelList path={path} generalPropouse={false}/>}
                    </Col>
                </Row>
            </div>
        </>
    );
}

const mapStateToProps = _ => ({
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setApp,
});

export default connect(mapStateToProps, mapActionsToProps)(Label)